// import store from "../store/rootStore";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  return process.env.REACT_APP_LIBRARY_ENDPOINT;
};
